<template>
  <div class="class-jiading-container">
    <div class="home_title">
      <span>{{ typeName }}</span>
    </div>
    <div class="content">
      <ul style="position: absolute; z-index: 10;">
        <li v-for="(item, index) in jiadingClass" :key="index" class="class-list">
          <div
            class="type"
            :style="{
              background: `url(${item.typeBg}) no-repeat center`,
              'background-size': '100% 100%',
              height: `${item.height}`
            }"
          >
            <!-- {{ item.type }} -->
          </div>
          <div class="class-wrapper">
            <div
              v-for="(cls, i) in item.classList"
              :key="i"
              class="class-content"
              :style="{
                background: `url(${cls.bg}) no-repeat center / 100% 100%`
              }"
            >
              <p class="class-title">
                <span>{{ cls.title }}</span>
                <img @click="handleCardVideo(cls)" src="@/assets/imgs/jiading/open-icon.png" />
              </p>
              <p class="class-desc" :style="{ color: `${cls.fc}` }">{{ cls.term }}</p>
            </div>
          </div>
        </li>
      </ul>
      <div class="student-bg"></div>
      <div class="circle-wrapper">
        <div
          @mouseenter="isActive1 = true"
          :class="isActive1 ? 'active' : 'default'"
          class="default-circle"
          style="transform: scale(1);top: 203px;right: 180px;"
        >
          <img class="circle-img" src="@/assets/imgs/jiading/jc-6.webp" alt />
          <img class="title-img" src="@/assets/imgs/jiading/jc-txt-6.webp" alt />
        </div>

        <div
          @mouseleave="isActive1 = false"
          :class="isActive1 ? 'active' : 'default'"
          class="active-circle"
          style="transform: scale(1);top: 178px;right: 156px;"
        >
          <img class="circle-img" src="@/assets/imgs/jiading/jc-1.webp" alt />
          <img class="title-img" src="@/assets/imgs/jiading/jc-txt-3.webp" alt />
        </div>

        <div
          @mouseenter="isActive2 = true"
          :class="isActive2 ? 'active' : 'default'"
          class="default-circle"
          style="transform: scale(1);top: 175px;right: 0px;"
        >
          <img class="circle-img" src="@/assets/imgs/jiading/jc-6.webp" alt />
          <img class="title-img" src="@/assets/imgs/jiading/jc-txt-5.webp" alt />
        </div>

        <div
          @mouseleave="isActive2 = false"
          :class="isActive2 ? 'active' : 'default'"
          class="active-circle"
          style="transform: scale(1);top: 151px;right: -23px;"
        >
          <img class="circle-img" src="@/assets/imgs/jiading/jc-1.webp" alt />
          <img class="title-img" src="@/assets/imgs/jiading/jc-txt-2.webp" alt />
        </div>
        <div
          @mouseenter="isActive3 = true"
          :class="isActive3 ? 'active' : 'default'"
          class="default-circle"
          style="transform: scale(1);top: 345px;right: -17px;"
        >
          <img class="circle-img" src="@/assets/imgs/jiading/jc-6.webp" alt />
          <img class="title-img" src="@/assets/imgs/jiading/jc-txt-4.webp" alt />
        </div>
        <div
          @mouseleave="isActive3 = false"
          :class="isActive3 ? 'active' : 'default'"
          class="active-circle"
          style="transform: scale(1);top: 319px;right: -40px;"
        >
          <img class="circle-img" src="@/assets/imgs/jiading/jc-1.webp" alt />
          <img class="title-img" src="@/assets/imgs/jiading/jc-txt-1.webp" alt />
        </div>
      </div>
    </div>
    <VideoPop :showVideo="showVideo" :fileUrl="fileUrl" @closeVideo="closeVideo"></VideoPop>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import VideoPop from '@/components/common/videoPop'

export default {
  props: {
    typeName: {
      type: String,
      default: '课程'
    },
    classesData: {
      type: Array,
      default: []
    }
  },
  computed: {
    ...mapState({
      QiNiuPath: (state) => state.indexStore.QiNiuPath
    })
  },
  components: {
    VideoPop
  },
  data() {
    return {
      showVideo: false, // 视频弹窗
      fileUrl: '',
      jiadingClass: [
        {
          type: 1,
          height: '162px',
          typeBg: require('@/assets/imgs/jiading/jc-3.webp'),
          classList: []
        },
        {
          type: 2,
          height: '352px',
          typeBg: require('@/assets/imgs/jiading/jc-2.webp'),
          classList: []
        },
        {
          type: 3,
          height: '162px',
          typeBg: require('@/assets/imgs/jiading/jc-4.webp'),
          classList: []
        }
      ],
      isActive1: false,
      isActive2: false,
      isActive3: false
    }
  },
  mounted() {
    setTimeout(() => {
      const list = [...this.classesData]
      const typeList1 = list.splice(0, 2)
      const typeList2 = list.splice(0, 4)
      const typeList3 = list.splice(0, 2)
      const jiadingList = this.jiadingClass

      for (let i = 0; i < typeList1.length; i++) {
        let obj = {}
        obj.bg = this.QiNiuPath + typeList1[i].baseCourseImage
        obj.title = typeList1[i].baseCourseName
        obj.term = typeList1[i].baseCourseDesc
        obj.video = this.QiNiuPath + typeList1[i].baseCourseVideo
        obj.fc = '#FF7334'
        jiadingList[0].classList.push(obj)
      }
      for (let i = 0; i < typeList2.length; i++) {
        let obj = {}
        obj.bg = this.QiNiuPath + typeList2[i].baseCourseImage
        obj.title = typeList2[i].baseCourseName
        obj.term = typeList2[i].baseCourseDesc
        obj.video = this.QiNiuPath + typeList2[i].baseCourseVideo
        obj.fc = '#55B5FF'
        jiadingList[1].classList.push(obj)
      }
      for (let i = 0; i < typeList3.length; i++) {
        let obj = {}
        obj.bg = this.QiNiuPath + typeList3[i].baseCourseImage
        obj.title = typeList3[i].baseCourseName
        obj.term = typeList3[i].baseCourseDesc
        obj.video = this.QiNiuPath + typeList3[i].baseCourseVideo
        obj.fc = '#0BA784'
        jiadingList[2].classList.push(obj)
      }
    }, 200)
  },
  methods: {
    handleCardVideo(item) {
      if (item.video) {
        this.fileUrl = item.video
        this.showVideo = true
      }
    },
    closeVideo() {
      this.showVideo = false
    },
  }
}
</script>

<style lang="scss" scoped>
@import "../../style/mixin.scss";

.class-jiading-container {
  width: 1200px;
  height: 896px;
  margin: 0 auto 54px auto;
  .home_title {
    @include sc(40px);
    font-weight: bold;
    text-align: center;
    margin: 0 auto 50px auto;
    width: 1200px;
    position: relative;
    &::after {
      content: "";
      display: block;
      @include wh(70px, 3px);
      background: #5d5aed;
      margin: 7px auto 0 auto;
    }
  }
  .content {
    position: relative;
    height: inherit;
    .class-list {
      display: flex;
      margin-bottom: 30px;
      .type {
        width: 330px;
        // height: 162px;
        margin-right: 10px;
      }
      .class-wrapper {
        width: 538px;
        display: flex;
        flex-wrap: wrap;
        .class-content {
          width: 253px;
          height: 162px;
          border-radius: 20px;
          overflow: hidden;
          margin-right: 16px;
          padding: 26px 0 0 24px;
          // cursor: pointer;
          transition: transform 0.4s;
          &:hover {
            transform: scale(1.1);
          }
          .class-title {
            max-width: 200px;
            display: flex;
            align-items: center;
            span {
              display: inline-block;
              max-width: 200px;
              font-size: 24px;
              font-weight: bold;
              @include txtflow();
            }

            img {
              width: 26px;
              height: 23px;
              margin-left: 8px;
              cursor: pointer;
              &:hover {
                animation-name: upAnimation;
                transform-origin: center bottom;
                animation-duration: 2s;
                animation-fill-mode: both;
                animation-iteration-count: infinite;
                animation-delay: 0.2s;
              }
            }
          }
          .class-desc {
            font-size: 17px;
            font-weight: 400;
            width: 150px;
            @include mtxtflow(3);
          }
        }
      }
    }
    .student-bg {
      width: 506px;
      height: 348px;
      background: url("../../assets/imgs/jiading/jc-5.webp") no-repeat center;
      background-size: 100% 100%;
      position: absolute;
      right: -41px;
      bottom: 118px;
    }
    .circle-wrapper {
      position: absolute;
      top: 0;
      right: 0;
      .default-circle {
        cursor: pointer;
        position: absolute;
        .circle-img {
          width: 116px;
          height: 116px;
        }
        .title-img {
          width: 40px;
          // height: 34px;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
        }
      }
      .active-circle {
        cursor: pointer;
        position: absolute;
        opacity: 0;
        visibility: hidden;

        .circle-img {
          width: 163px;
          height: 163px;
        }
        .title-img {
          width: 48px;
          // height: 34px;
          position: absolute;
          top: 51%;
          left: 50%;
          transform: translate(-50%, -50%);
        }
      }
      .active {
        opacity: 1;
        visibility: visible;
        transition: opacity 0.2s ease 0s, visibility 0s 0s;
        .circle-img {
          transform: rotate(180deg);
          transition: transform 0.6s ease-in-out 0s;
        }
      }
      .default {
        transition: opacity 0.2s ease 0s, visibility 0s 0.2s;
        .circle-img {
          transform: rotate(0deg);
          transition: transform 0.3s ease-in-out 0s;
        }
      }
    }
  }
}
@keyframes upAnimation {
  0% {
    transform: rotate(0deg);
    transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }

  10% {
    transform: rotate(-12deg);
    transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }

  20% {
    transform: rotate(12deg);
    transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }

  28% {
    transform: rotate(-10deg);
    transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }

  36% {
    transform: rotate(10deg);
    transition-timing-function: cubic-bezier(0.755, 0.5, 0.855, 0.06);
  }

  42% {
    transform: rotate(-8deg);
    transition-timing-function: cubic-bezier(0.755, 0.5, 0.855, 0.06);
  }

  48% {
    transform: rotate(8deg);
    transition-timing-function: cubic-bezier(0.755, 0.5, 0.855, 0.06);
  }

  52% {
    transform: rotate(-4deg);
    transition-timing-function: cubic-bezier(0.755, 0.5, 0.855, 0.06);
  }

  56% {
    transform: rotate(4deg);
    transition-timing-function: cubic-bezier(0.755, 0.5, 0.855, 0.06);
  }

  60% {
    transform: rotate(0deg);
    transition-timing-function: cubic-bezier(0.755, 0.5, 0.855, 0.06);
  }

  100% {
    transform: rotate(0deg);
    transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }
}
</style>
